<template>
    <div class="pt-3 px-2" v-if="refresh" data-cy="container_profile_address_tax_form_main">
        <InputRadio
                v-model:inputValue="addressModel.personType"
                :inputLbl="lbl.tax.personType"
                :itemList="personTypeValue"
                :errorInfo="errorInfo[0]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                data-cy="input_profile_address_tax_person_type"
        ></InputRadio>
        <div v-if="addressModel.personType == 'individual'">
            <InputRadio
                v-model:inputValue="addressModel.title"
                :inputLbl="lbl.tax.title"
                :itemList="prefixValue"
                :errorInfo="errorInfo[1]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                data-cy="input_profile_address_tax_title"
            ></InputRadio>
            <InputText
                v-model:inputValue="addressModel.firstname"
                :errorInfo="errorInfo[2]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.firstname"
                data-cy="input_profile_address_tax_firstname"
            ></InputText>
            <InputText
                v-model:inputValue="addressModel.lastname"
                :errorInfo="errorInfo[3]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.lastname"
                data-cy="input_profile_address_tax_lastname"
            ></InputText>
        </div>
        <div v-if="addressModel.personType == 'company'">
            <InputText
                v-model:inputValue="addressModel.companyName"
                :errorInfo="errorInfo[4]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.companyName"
                data-cy="input_profile_address_tax_company_name"
            ></InputText>
        </div>
        <InputNationalId
                key="input-address-taxid"
                v-model:inputValue="addressModel.taxId"
                :errorInfo="errorInfo[5]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.nationalid"
                data-cy="input_profile_address_tax_id"
        ></InputNationalId>
        <InputContactNumber
                key="input-address-contactnumber"
                v-model:inputValue="addressModel.contactNumber"
                :minLength="10"
                :maxLength="12"
                delimeter="-"
                :errorInfo="errorInfo[6]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.contactnumber"
                data-cy="input_profile_address_tax_contact_number"
        ></InputContactNumber>
        <InputEmail
                key="input-address-email"
                v-model:inputValue="addressModel.email"
                :maxLength="50"
                :errorInfo="errorInfo[7]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.email"
                data-cy="input_profile_address_tax_email"
        ></InputEmail>
        <InputText
                key="input-address-building"
                v-model:inputValue="addressModel.building"
                :errorInfo="errorInfo[8]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.building"
                data-cy="input_profile_address_tax_building"
        ></InputText>
        <InputText
                key="input-address-room"
                v-model:inputValue="addressModel.room"
                :errorInfo="errorInfo[9]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.room"
                data-cy="input_profile_address_tax_room"
        ></InputText>
        <InputNumber
                key="input-address-floor"
                v-model:inputValue="addressModel.floor"
                :errorInfo="errorInfo[10]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.floor"
                data-cy="input_profile_address_tax_floor"
        ></InputNumber>
        <InputText
                key="input-address-villege"
                v-model:inputValue="addressModel.village"
                :errorInfo="errorInfo[11]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.village"
                data-cy="input_profile_address_tax_village"
        ></InputText>
        <InputText
                key="input-address-number"
                v-model:inputValue="addressModel.number"
                :errorInfo="errorInfo[12]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.number"
                data-cy="input_profile_address_tax_number"
        ></InputText>
        <InputText
                key="input-address-moo"
                v-model:inputValue="addressModel.moo"
                :errorInfo="errorInfo[13]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.moo"
                data-cy="input_profile_address_tax_moo"
        ></InputText>
        <InputText
                key="input-address-soi"
                v-model:inputValue="addressModel.soi"
                :errorInfo="errorInfo[14]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.soi"
                data-cy="input_profile_address_tax_soi"
        ></InputText>
        <InputText
                key="input-address-road"
                v-model:inputValue="addressModel.road"
                :errorInfo="errorInfo[15]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.road"
                data-cy="input_profile_address_tax_road"
        ></InputText>
        <FormAddressDropdown
                v-model:inputValue="formAddressModel"
                :errorInfo="errorInfo[16]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping"
                data-cy="container_profile_address_tax_dropdown"
        ></FormAddressDropdown>
    </div>
</template>
<script>
// import Util from '@/helper/Utility.js';
import { FormHelper, DropdownListValue } from '@/helper/FormHelper.js';
//component
import InputText from '@/components/Input/label/InputText.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import FormAddressDropdown from '@/components/Form/FormAddressDropdown.vue';
import InputRadio from '@/components/Input/label/InputRadio.vue';
import InputNationalId from '@/components/Input/label/InputNationalId.vue';
import InputEmail from '@/components/Input/label/InputEmail.vue';
import InputNumber from '@/components/Input/label/InputNumber.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
//service
import { AddressModel } from '@/core/Address/model/AddressModel.js';
import { AddressListModel } from '@/core/Address/model/AddressListModel.js';

export default {
    name: 'FormTaxAddress',
    mixins: [LocaleMixin],
    components: {
        InputText,
        InputContactNumber,
        FormAddressDropdown,
        InputRadio,
        InputNationalId,
        InputEmail,
        InputNumber,
    },
    data: function() {
        return {
            personTypeValue: [],
            prefixValue: [],
            isSubmitted: false,
            errorInfo: [],
            refresh: true,

            formAddressModel: null,
            addressModel: null,
        };
    },
    created: function() {
        this.initForm(null);
        this.setupFormValue();

    },
    methods: {
        initForm: function(address) {
            this.isSubmitted = false;

            if (address != null) {
                this.addressModel = {...address};
                this.formAddressModel.setValueFromAddressListModel(this.addressModel);
            } else {
                this.addressModel = new AddressListModel();
                this.formAddressModel = new AddressModel();
            }


            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },
        setupFormValue: function() {
            this.errorInfo = FormHelper.genErrorInfo(17);

            var personType = new DropdownListValue();
            personType.add("บุคคลธรรมดา", "individual");
            personType.add("นิติบุคคล", "company");
            this.personTypeValue = personType.getList();

            var prefixValue = new DropdownListValue();
            prefixValue.add("นาย", "mr");
            prefixValue.add("นางสาว", "ms");
            prefixValue.add("นาง", "mss");
            this.prefixValue = prefixValue.getList();
        },
        clearForm: function() {
            this.initForm(null);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                this.addressModel.setValueFromAddressModel(this.formAddressModel);
                this.addressModel.setIsTax();
                return this.addressModel;
            }
            return null
        },
        validate: function() {
            // return FormHelper.validate(this.errorInfo);
             for (let i=0 ; i<17 ; i++) {
                if (this.addressModel.personType == 'individual') {
                    if (i == 4) {
                        continue;
                    }
                } else if (this.addressModel.personType == 'company') {
                    if (i >= 1 && i <= 3) {
                        continue;
                    }
                }

                if (!this.errorInfo[i].isValid) {
                    return false;
                }
            }

            return true;
        },
    },
}
</script>
